export default "__VITE_ASSET__g5yNf1F0__"